module.exports = __webpack_public_path__ + "media/images/Decorative Fireplace-b278c605.webp";